import React from 'react';
import { Box, Typography, Container, Paper, Link as MuiLink } from '@mui/material';

import ContactUs2 from './contactUs2';
import Footer from './footer';

const Support = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box 
            sx={{ 
                minHeight: '100vh', 
                display: 'flex', 
                flexDirection: 'column', 
                //bgcolor: '#f9fafb' // Equivalente a un bg-gray-50 suave
            }}
        >

            <ContactUs2
                    title='¿En qué podemos ayudarte?'
                    description='Estamos aquí para garantizar que tu experiencia con tu QUD y nuestros servicios sea impecable. Déjanos tus datos y nos pondremos en contacto contigo.'
                />
        </Box>
    );
};

export default Support;